import { lastValueFrom } from 'rxjs';
import { BaseService } from './base-service';
export class SubmissionService {
    static getSubmissions(filter, pageNumber) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        return lastValueFrom(BaseService.getPaginated(`submissions?filter=${qs}`, pageNumber));
    }
    static fetchSubmission(oid) {
        return lastValueFrom(BaseService.get(`submissions/${oid}`));
    }
    static saveSubmission(dto) {
        return lastValueFrom(BaseService.save(`submissions`, dto));
    }
    static deleteSubmission(oid) {
        return lastValueFrom(BaseService.delete(`submissions/${oid}`));
    }
    // public static searchSubmissionCombo(selfId: number, search: string) {
    //   let qs = encodeURIComponent(search);
    //   return lastValueFrom(BaseService.get<IDropdownItem[]>(`submissions-search-dropdown/${selfId}?search=${qs}`));
    // }
    // ----------------------------------------------------------------------
    // Stats
    // ----------------------------------------------------------------------
    static getWinningSubmissions(filter, pageNumber) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        return lastValueFrom(BaseService.getPaginated(`submissions-winning?filter=${qs}`, pageNumber));
    }
    static getSubmissionSubtasks(submissionId) {
        return lastValueFrom(BaseService.get(`submission-subtasks/${submissionId}`));
    }
    // public static fetchSubmissionStats(oid: number) {
    //   //return lastValueFrom(BaseService.get<IDossierStatsDTO>(`submissions-stats/${oid}`));
    //   return null;
    // }
    // ----------------------------------------------------------------------
    // Download source code
    // ----------------------------------------------------------------------
    static exportSubmissionSourceCode(submissionId) {
        //let dateString = (new Date()).toISOString().replace(/[:\.]/g, '');
        //let filename = "attività_" + dateString + ".xlsx";
        BaseService.downloadFile(`submission-download-source/${submissionId}`, null, null);
    }
    static exportSubmissionOutput(submissionId) {
        //let dateString = (new Date()).toISOString().replace(/[:\.]/g, '');
        //let filename = "attività_" + dateString + ".xlsx";
        BaseService.downloadFile(`submission-download-output/${submissionId}`, null, null);
    }
    // ----------------------------------------------------------------------
    // User Scores (hall of fame)
    // ----------------------------------------------------------------------
    static getUsersScores(filter) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        return lastValueFrom(BaseService.get(`users-scores?filter=${qs}`));
    }
    // ----------------------------------------------------------------------
    // My Default Compiler
    // ----------------------------------------------------------------------
    static getMyDefaultCompiler() {
        return lastValueFrom(BaseService.get(`submissions-my-default-compiler`));
    }
}
